import "./src/assets/sass/styles.sass";
const netlifyIdentity = require("netlify-identity-widget");
netlifyIdentity.init({
  locale: "en", // defaults to 'en'
});

//gatsby-browser.js
// gatsby-browser.js
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (typeof window === "undefined") return false;

  window.history.scrollRestoration = "manual";

  const currentPosition = getSavedScrollPosition(location) || [0, 0];

  const scrollToPosition = () => {
    if (location.hash) {
      const item = document.querySelector(location.hash);
      if (item) {
        item.scrollIntoView({ behavior: "smooth" });
      } else {
        // If the element doesn't exist yet, try again on the next frame
        requestAnimationFrame(scrollToPosition);
      }
    } else {
      window.scrollTo({
        top: currentPosition[1],
        left: currentPosition[0],
        behavior: "instant",
      });
    }
  };

  // Wait for the next animation frame to ensure DOM is ready
  requestAnimationFrame(scrollToPosition);

  // Prevent Gatsby from handling scroll
  return false;
};
